import { render, staticRenderFns } from "./CoursewareRibbon.vue?vue&type=template&id=3a953682&"
import script from "./CoursewareRibbon.vue?vue&type=script&lang=js&"
export * from "./CoursewareRibbon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports